import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getFormValues } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import Progress from 'components/common/Progress';

import { fetchUserNotificationsHistory, clearUserNotificationsHistory } from 'redux/modules/userNotificationsHistory';

import dateFormat from 'config/dateFormat';
import * as validate from 'utils/validate';

import NotificationsItem from './NotificationsItem';
import NotificationsFilterForm from './NotificationsFilterForm';

const styles = theme => ({
  root: {
    position: 'relative',
    minHeight: '100%',
    boxSizing: 'border-box',
    padding: 16,
  },
  rootEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  notificationsList: {
    paddingTop: 16,
  },
  form: {
    padding: 16,
    marginRight: 48,
    [theme.breakpoints.down('xs')]: {
      padding: '8px 8px 0 8px',
      marginRight: 0,
    },
  },
});

class NotificationsHistoryDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 50,
      offset: 0,
      triggerLoading: true,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
    this.onUserNotificationsScrollFetchRequest = this.onUserNotificationsScrollFetchRequest.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { loading, filters, initialized } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged =
      filters['Notification Type'] !== nextProps.filters['Notification Type']
      || filters['Date From'] !== nextProps.filters['Date From']
      || filters['Date To'] !== nextProps.filters['Date To']
      || filters['User ID'] !== nextProps.filters['User ID']
      || filters['Watcher User ID'] !== nextProps.filters['Watcher User ID']
      || filters['Patient ID'] !== nextProps.filters['Patient ID'];
    const newState = {};
    if (filtersChanged) {
      newState.offset = 0;
    } else if (initialized
      && loading === 0
      && this.scrollbarsRef
      && this.scrollbarsRef.getScrollHeight() <= this.scrollbarsRef.getClientHeight()
      && (nextProps.userNotificationsHistory.length - limit) >= offset) {
      newState.offset = offset + limit;
    }
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { initialized, filters, userNotificationsUniqAdjustment, open } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const filtersChanged =
      filters['Notification Type'] !== prevProps.filters['Notification Type']
      || filters['Date From'] !== prevProps.filters['Date From']
      || filters['Date To'] !== prevProps.filters['Date To']
      || filters['User ID'] !== prevProps.filters['User ID']
      || filters['Watcher User ID'] !== prevProps.filters['Watcher User ID']
      || filters['Patient ID'] !== prevProps.filters['Patient ID'];
    if (open && initialized && (!prevProps.initialized
      || limitChanged || offsetChanged || filtersChanged)) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions, userNotificationsHistory, account, filters } = this.props;
    const { limit, offset, triggerLoading,  } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let val = filters[key];
        switch (key) {
          case 'User ID':
            name = 'Assigned User ID';
            break;
          case 'Watcher User ID':
            name = 'Watcher ID';
            break;
          case 'Notification Type':
            val = [filters[key]];
            break;
          default:
        }
        return {
          name,
          val,
        };
      })
      : [];
    actions.fetchUserNotificationsHistory({
      limit,
      offset,
      triggerLoading: offset === 0,
      filters: requestFilters,
      push: offset > 0,
    });
  }

  onDialogEnter() {
    this.onRequest();
  }

  onDialogExited() {
    const { actions } = this.props;
    this.setState({ offset: 0 });
    actions.clearUserNotificationsHistory();
  }

  onUserNotificationsScrollFetchRequest() {
    const { offset, limit } = this.state;
    if ((this.props.userNotificationsHistory.length - limit) >= offset) {
      this.setState({ offset: offset + limit });
    }
  }

  render() {
    const { userNotificationsHistory, business, loading, open, onClose, account, actions, classes } = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        onExited={this.onDialogExited}
        maxWidth="md"
      >
        <DialogTitle
          onCloseClick={onClose}
          secondaryContent={(
            <NotificationsFilterForm
              className={classes.form}
              form="notificationsHistoryFilter"
              account={account}
            />
          )}
        >
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            Notifications History
          </Typography>
        </DialogTitle>
        <DialogContent
          withScrollbars
          fullHeight
          scrollbarsRef={(scrollbarsRef) => {
            this.scrollbarsRef = scrollbarsRef;
          }}
          onScrollFrame={(event) => {
            if (event.top > 0.8) {
              this.onUserNotificationsScrollFetchRequest();
            }
          }}
        >
          {loading > 0 ? (
            <Progress />
          ) : (
            <div className={classes.notificationsList}>
              {userNotificationsHistory.length > 0 ? (
                <Table className={classes.table}>
                  <TableBody>
                    {userNotificationsHistory.map(item => (
                      <NotificationsItem
                        key={item.ID}
                        business={business}
                        {...item}
                        onClick={() => {}}
                        onPatientItemClick={() => {}}
                        onPatientNotificationsLoad={(values) => {
                          actions.fetchUserNotificationsHistory({
                            filters: [{
                              name: 'Patient ID',
                              val: values['Patient ID'],
                            }],
                            patientNotifications: true,
                          });
                        }}
                      />
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography variant="caption" align="center">
                  No notifications in history
                </Typography>
              )}
            </div>        
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

NotificationsHistoryDialog.propTypes = {
  userNotificationsHistory: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchUserNotificationsHistory: PropTypes.func.isRequired,
    clearUserNotificationsHistory: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootEmpty: PropTypes.string.isRequired,
  }).isRequired,
};

NotificationsHistoryDialog.defaultProps = {
  business: {},
};

const mapStateToProps = store => {
  const filterFormValues = getFormValues('notificationsHistoryFilter')(store);
  const filters = {
    ...filterFormValues
      && filterFormValues['Date of Creation From']
      && !validate.date(filterFormValues['Date of Creation From'])
      && moment(filterFormValues['Date of Creation From'], dateFormat).isValid()
      ? { 'Date From': moment(filterFormValues['Date of Creation From'], dateFormat).format(dateFormat) }
      : {},
    ...filterFormValues
      && filterFormValues['Date of Creation To']
      && !validate.date(filterFormValues['Date of Creation To'])
      && moment(filterFormValues['Date of Creation To'], dateFormat).isValid()
      ? { 'Date To': moment(filterFormValues['Date of Creation To'], dateFormat).format(dateFormat) }
      : {},
    ...filterFormValues
      && filterFormValues['User ID']
      ? { 'User ID': filterFormValues['User ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Watcher User ID']
      ? { 'Watcher User ID': filterFormValues['Watcher User ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Patient ID']
      ? { 'Patient ID': filterFormValues['Patient ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Notification Type']
      ? { 'Notification Type': filterFormValues['Notification Type'] }
      : {},
  };
  return {
    userNotificationsHistory: store.userNotificationsHistory.data,
    initialized: store.userNotifications.initialized,
    account: store.account,
    loading: store.userNotificationsHistory.loading,
    business: store.business.data,
    filters,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchUserNotificationsHistory, clearUserNotificationsHistory }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(NotificationsHistoryDialog),
);



// WEBPACK FOOTER //
// ./src/components/home/Notifications/NotificationsHistoryDialog.js